import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=736cc540&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=736cc540&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736cc540",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('736cc540')) {
      api.createRecord('736cc540', component.options)
    } else {
      api.reload('736cc540', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=736cc540&scoped=true", function () {
      api.rerender('736cc540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/financial/wallet_settlements/Index.vue"
export default component.exports